import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {
  SettingsDevelopersApplicationFeaturesUrl,
  SettingsDevelopersApplicationInfoUrl,
  SettingsDevelopersApplicationOAuthUrl,
  SettingsDevelopersApplicationServersUrl,
} from '../../../../models/url/settingsUrlModel';
import {AppState} from '../../../../store/appState';
import {getLocalApplications} from '../../../../store/data/localApplications/localApplicationsSelectors';
import {
  getIsSettingsLocalApplicationAsyncStatus,
  getIsSettingsLocalApplicationLoading,
  getSettingsPanelResources,
} from '../../../../store/panels/settings/settingsPanelSelectors';
import {isSettingsResourcesDevelopersResource} from '../../../../store/panels/settings/settingsPanelState';
import {SettingsDevelopersApplicationPage} from './settingsDevelopersApplicationPage';

/*
 * Props.
 */

interface SettingsDevelopersApplicationPageContainerProps {
  url:
    | SettingsDevelopersApplicationFeaturesUrl
    | SettingsDevelopersApplicationInfoUrl
    | SettingsDevelopersApplicationServersUrl
    | SettingsDevelopersApplicationOAuthUrl;
}

/*
 * Selectors.
 */

function getUrl(_state: AppState, props: SettingsDevelopersApplicationPageContainerProps) {
  return props.url;
}

const getApplication = createSelector(
  [getSettingsPanelResources, getLocalApplications, getUrl],
  (resources, applications, url) => {
    if (!resources || !isSettingsResourcesDevelopersResource(resources)) {
      return undefined;
    }
    if (!resources.localApplicationId || resources.localApplicationId !== url.applicationId) {
      return undefined;
    }
    return applications[resources.localApplicationId];
  },
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsDevelopersApplicationPageContainerProps>()(() => ({
  application: getApplication,
  isApplicationLoading: getIsSettingsLocalApplicationLoading,
  asyncStatus: getIsSettingsLocalApplicationAsyncStatus,
}));

export const SettingsDevelopersApplicationPageContainer = connect(mapStateToProps)(
  SettingsDevelopersApplicationPage,
);
